import { googleOAuth } from "../auth-config";

const AUTH_URL = "https://accounts.google.com/o/oauth2/v2/auth";
/** Holodeck MVP scopes: openid, email, profile */
export const GOOGLE_SCOPES = ["openid", "email", "profile"].join(" ");

function base64Url(bytes: ArrayBuffer): string {
  const bin = String.fromCharCode(...new Uint8Array(bytes));
  return btoa(bin).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}

export async function sha256Base64Url(input: string): Promise<string> {
  const data = new TextEncoder().encode(input);
  const digest = await crypto.subtle.digest("SHA-256", data);
  return base64Url(digest);
}

function randomUrlSafeString(byteLength = 32): string {
  const bytes = new Uint8Array(byteLength);
  crypto.getRandomValues(bytes);
  let bin = "";
  for (const b of bytes) bin += String.fromCharCode(b);
  return btoa(bin).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}

export async function createPkcePair(): Promise<{ verifier: string; challenge: string }> {
  const verifier = randomUrlSafeString(48);
  const challenge = await sha256Base64Url(verifier);
  return { verifier, challenge };
}

export function buildGoogleAuthorizeUrl(params: { codeChallenge: string; state: string }): string {
  const { clientId, redirectUri } = googleOAuth;
  if (!clientId) throw new Error("Google OAuth client id is not configured");

  const q = new URLSearchParams({
    client_id: clientId,
    redirect_uri: redirectUri,
    response_type: "code",
    scope: GOOGLE_SCOPES,
    code_challenge: params.codeChallenge,
    code_challenge_method: "S256",
    state: params.state,
    prompt: "select_account",
  });

  return `${AUTH_URL}?${q.toString()}`;
}
